import { useQueryState } from "@msuite/ui/libs/nuqs";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { Enums, ProjectInvoice } from "@msuite/utils/types";
import { client } from "@/hono";
import type { ProjectPanelBaseProps } from "../types";
import { ProjectInvoicesMenu } from "./project-invoices-menu";
import { columns } from "./table-config";

/** Props Interface */
interface ProjectInvoicesProps extends ProjectPanelBaseProps {}

export function ProjectInvoices({ projectId }: ProjectInvoicesProps) {
	/** Hooks */
	const [invoicesStateQuery] = useQueryState("invoices-state", {
		defaultValue: "all",
		clearOnDefault: true,
	});

	/** Query */
	const { data, queryKey, refetch, isLoading } = useQuery({
		queryKey: ["invoices", projectId, invoicesStateQuery],
		queryFn: async () => {
			const response = await client.projects[":projectId"].invoices.$get({
				param: {
					projectId,
				},
				query: {
					state: invoicesStateQuery as Enums<"outgoingInvoiceState"> | "all",
				},
			});
			const data = await responseHandler(response);
			return data.invoices as ProjectInvoice[];
		},
	});

	/** Render */
	return (
		<DataTable
			persistenceKey="project-invoices-table"
			columns={columns}
			data={data ?? []}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<ProjectInvoicesMenu projectId={projectId} />}
		/>
	);
}
